import HttpHelpers from './helpers';

const CountriesApiEndpoints = {
  getCountriesWithCities: () => {
    return HttpHelpers.unAuthenticatedAxios
      .get('country?with[]=cities')
      .then((response) => response.data);
  },
};

export default CountriesApiEndpoints;
